export default theme => {
  const RADIUS_STANDARD = `${theme.shape.borderRadius}px`;
  const NO_BORDER_TOP_LEFT_RADIUS = `0 ${RADIUS_STANDARD} ${RADIUS_STANDARD} ${RADIUS_STANDARD}`;
  const NO_BORDER_TOP_RIGHT_RADIUS = `${RADIUS_STANDARD} 0 ${RADIUS_STANDARD} ${RADIUS_STANDARD}`;
  const NO_BORDER_BOTTOM_RIGHT_RADIUS = `${RADIUS_STANDARD} ${RADIUS_STANDARD} 0 ${RADIUS_STANDARD}`;
  const NO_BORDER_BOTTOM_LEFT_RADIUS = `${RADIUS_STANDARD} ${RADIUS_STANDARD} ${RADIUS_STANDARD} 0`;

  return {
    root: {
      backgroundColor: theme.palette.primary.main,
      height: 145,
      padding: 25,
      position: "relative",
      zIndex: 1,
      overflow: "hidden",
      [theme.breakpoints.only("sm")]: {
        width: 220
      },
      [theme.breakpoints.only("md")]: {
        width: 230
      },
      [theme.breakpoints.only("lg")]: {
        width: 250
      }
    },
  
    allBorderRadius: {
      borderRadius: RADIUS_STANDARD,
  
      "& $backgroundIcon": {
        borderRadius: RADIUS_STANDARD
      }
    },
  
    noBorderTopLeftRadius: {
      borderRadius: NO_BORDER_TOP_LEFT_RADIUS,
  
      "& $backgroundIcon": {
        borderRadius: NO_BORDER_TOP_LEFT_RADIUS
      }
    },
    noBorderTopRightRadius: {
      borderRadius: NO_BORDER_TOP_RIGHT_RADIUS,
  
      "& $backgroundIcon": {
        borderRadius: NO_BORDER_TOP_RIGHT_RADIUS
      }
    },
    noBorderBottomRightRadius: {
      borderRadius: NO_BORDER_BOTTOM_RIGHT_RADIUS,
  
      "& $backgroundIcon": {
        borderRadius: NO_BORDER_BOTTOM_RIGHT_RADIUS
      }
    },
    noBorderBottomLeftRadius: {
      borderRadius: NO_BORDER_BOTTOM_LEFT_RADIUS,
  
      "& $backgroundIcon": {
        borderRadius: NO_BORDER_BOTTOM_LEFT_RADIUS
      }
    },
  
    icon: {
      color: theme.palette.common.white,
      width: 45,
      height: 36
    },
  
    backgroundIcon: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: -1,
      opacity: 0.09,
      backgroundColor: "transparent",
  
      "& $icon": {
        width: "auto",
        height: 145,
        transform: "scale(1) translate(-20px, 18px)",
        transformOrigin: "0% 100%"
      }
    },

    backgroundIconPgm: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: -1,
      opacity: 0.09,
      backgroundColor: "transparent",
  
      "& $icon": {
        width: 191,
        height: 228,
        transform: "scale(1) translate(-20px, 18px)",
        transformOrigin: "0% 100%",
        marginLeft: -10
      }
    },
  
    text: {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightMedium,
      lineHeight: theme.typography.body2.lineHeight,
      color: theme.palette.common.white
    }
  }
};
